import React from "react";
import SaaSDtOverView from "../../../components/SaaSDtOverView";
import SaaSDtPlatform from "../../../components/SaaSDtPlatform";
import { Seo } from "../../../components/Seo";
import { useTranslation } from "react-i18next";

const SaaSDt = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={`${t("digitalTwin.saasDt.seo.title")}`} description={`${t("digitalTwin.saasDt.seo.des")}`} path="digital-transformation/saas-platform" />
      <SaaSDtOverView />
      <SaaSDtPlatform />
    </>
  );
};

export default SaaSDt;
